<template>
    <div>
        <Card>
            <Card>
                <p slot="title">{{t.log.searchName}}</p>
                <Form :model="formItem" :label-width="100" label-position="right">
                    <Row :gutter="16">
                        <Col span="8">
                            <Form-item :label="t.log.accountName">
                                <Input v-model="formItem.accountName"
                                       :placeholder="msgUtil.placeholderRequired(t.log.accountName)"></Input>
                            </Form-item>
                        </Col>
                        <Col span="8">
                            <Form-item :label="t.log.createStartTime">
                                <DatePicker type="datetime" format="yyyy/MM/dd HH:mm:ss"
                                            v-model="formItem.createStartTime" style="width: 100% !important"
                                            :placeholder="msgUtil.placeholderSelected(t.log.createStartTime)"
                                            :options="createStartTimeOption"
                                            @on-change="onStartTimeChange"></DatePicker>
                            </Form-item>
                        </Col>
                        <Col span="8">
                            <Form-item :label="t.log.createEndTime">
                                <DatePicker type="datetime" format="yyyy/MM/dd HH:mm:ss"
                                            v-model="formItem.createEndTime" style="width: 100% !important"
                                            :placeholder="msgUtil.placeholderSelected(t.log.createEndTime)"
                                            :options="createEndTimeOption" @on-change="onEndTimeChange"></DatePicker>
                            </Form-item>
                        </Col>

                    </Row>
                    <Row :gutter="16">
                        <Col span="8">
                            <Form-item :label="t.log.status">
                                <Select v-model="formItem.status" clearable style="width: 100% !important"
                                        :placeholder="msgUtil.placeholderSelected(t.log.status)">>
                                    <Option value="1">{{t.log.open}}</Option>
                                    <Option value="0">{{t.log.close}}</Option>
                                </Select>
                            </Form-item>
                        </Col>
                        <Col span="16">
                            <Button type="primary" icon="ios-search" style="float: right;" @click="search(true)">
                                {{msgUtil.message.action.search}}
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Card>
            <Row class="margin-top-10">
                <Col span="12">
                    <sort-button-group :buttons="sortButton" @on-order="orderClick"/>
                </Col>
            </Row>
            <Row class="margin-top-10">
                <Table ref="selection" :context="self" :columns="columns" :data="data" :loading="loading"
                ></Table>
            </Row>
            <Row class="margin-top-10" type="flex" justify="end">
                <Page ref="page" :total="total" show-total show-sizer @on-change="pageChange"
                      @on-page-size-change="pageSizeChange">
                    {{msgUtil.message.page.total}} {{ total }} {{msgUtil.message.page.paper}}
                </Page>
            </Row>
        </Card>
    </div>
</template>
<script>
import { getAccountLoginLogList } from '@/api/log';
import sortButtonGroup from '@/components/sort-button-group.vue';

export default {
    name: 'sys_monitor_log_loginlist',
    components: {
        sortButtonGroup,
    },
    data() {
        const t = this.$_t();
        const msgUtil = this.$msgUtil;
        const renderStatus = (h, params) => {
            const row = params.row;
            const color = row.status === '0' ? 'error' : row.status === '1' ? 'success' : 'error';
            const text =
                row.status === '0' ? t.log.close : row.status === '1' ? t.log.open : t.log.close;
            return h(
                'Tag',
                {
                    props: {
                        type: 'border',
                        color: color,
                    },
                },
                text
            );
        };
        return {
            self: this,
            t: t,
            msgUtil: msgUtil,
            formItem: {
                accountName: '',
                status: '',
                createTime: '',
                createStartTime: null,
                createEndTime: null,
                oa: '',
                od: '',
                current: 1,
                size: 10,
            },
            createStartTimeOption: {},
            createEndTimeOption: {},
            data: [],
            total: 0,
            columns: [
                { title: t.table.id, key: 'id', align: 'center', width: 164 },
                { title: t.table.logName, key: 'logName', align: 'center', tooltip: true },
                { title: t.table.accountName, key: 'accountName', align: 'center', tooltip: true },
                { title: t.table.ip, key: 'ip', align: 'center', tooltip: true },
                { title: t.table.msg, key: 'msg', align: 'center', tooltip: true },
                { title: t.table.createTime, key: 'createTime', align: 'center', tooltip: true },
                { title: ' ', align: 'center' },
                {
                    title: t.table.status,
                    key: 'status',
                    align: 'center',
                    render: renderStatus,
                },
            ],
            // 排序btn
            sortButton: [
                { key: 'accountName', value: t.log.accountName, order: 0 },
                { key: 'status', value: t.log.status, order: 0 },
                { key: 'createTime', value: t.log.createTime, order: 0 },
            ],
            loading: false,
        };
    },
    methods: {
        //排序
        async orderClick(btn) {
            this.formItem.oa = '';
            this.formItem.od = '';
            if (btn.order === 1) {
                this.formItem.oa = btn.key;
            } else if (btn.order === 2) {
                this.formItem.od = btn.key;
            }
            await this.search(true);
        },
        //数据检索
        async search(flg) {
            if (flg) {
                this.formItem.current = 1;
                this.$refs.page.currentPage = 1;
            }
            this.loading = true;
            await this.getCreateTime();

            const result = await getAccountLoginLogList(this.formItem);
            //console.log(result);
            if (result) {
                this.data = result.page.records;
                this.total = result.page.total;
            }
            this.loading = false;
        },
        //创建时间作成
        async getCreateTime() {
            this.formItem.createTime = '';
            if (this.formItem.createStartTime !== '' && this.formItem.createStartTime !== undefined) {
                this.formItem.createTime = this.formItem.createStartTime + ',';
            }
            if (this.formItem.createEndTime !== '' && this.formItem.createEndTime !== undefined) {
                if (this.formItem.createStartTime === '' || this.formItem.createStartTime === undefined) {
                    this.formItem.createTime = ',';
                }
                this.formItem.createTime += this.formItem.createEndTime;
            }
        },
        // 页号改变
        async pageChange() {
            this.formItem.current = this.$refs.page.currentPage;
            await this.search(false);
        },
        // 每页显示数据
        async pageSizeChange() {
            this.formItem.size = this.$refs.page.currentPageSize;
            await this.search(false);
        },
        /**
         * 开始时间发生变化时触发,设置结束时间不可选择的日期
         * 结束时间应大于等于开始时间,且小于等于当前时间
         * @param {string} startTime 格式化后的日期
         * @param {string} type 当前的日期类型
         */
        onStartTimeChange(startTime) {
            this.formItem.createStartTime = startTime;
            this.createEndTimeOption = {
                disabledDate(endTime) {
                    return endTime < new Date(startTime) || endTime > Date.now();
                },
            };
        },
        /**
         * 结束时间发生变化时触发,设置开始时间不可选择的日期
         * 开始时间小于等于结束时间,且小于等于当前时间
         * @param {string} date 格式化后的日期
         * @param {string} type 当前的日期类型
         */
        onEndTimeChange(endTime) {
            this.formItem.createEndTime = endTime;
            this.createStartTimeOption = {
                disabledDate(startTime) {
                    return startTime > new Date(endTime) || startTime > Date.now();
                },
            };
        },
    },
    async mounted() {
        await this.search(true);
    },
};
</script>
<style>
</style>
